// Shared configuration for both frontend and backend
// This file contains company-specific information that can be customized
export const sharedConfig = {
  // Brand Information - Single source of truth for user-facing content
  brand: {
    name: 'RecapVid',
    website: 'recapvid.com',
    websiteUrl: 'https://recapvid.com',
    tagline: 'Your fantasy league recap',
    description: 'AI-powered weekly recap videos that roast your fantasy football league'
  },

  // Company Information - Legal entity and business details
  company: {
    companyName: 'Teq Crew, LLC',
    companyUrl: 'https://teqcrew.com',
    dbaText: 'dba RecapVid'
  },

  // Social Media and External Links
  social: {
    discord: 'https://discord.gg/uF8BYKZPhx',
    platforms: {
      tiktok: {
        handle: '@recapvidai',
        url: 'https://tiktok.com/@recapvidai'
      },
      facebook: {
        handle: '@recapvid',
        url: 'https://facebook.com/recapvid'
      },
      instagram: {
        handle: '@recapvidai',
        url: 'https://instagram.com/recapvidai'
      },
      youtube: {
        handle: '@recapvidai',
        url: 'https://www.youtube.com/channel/UCI5D0KfMxZRKULw3h_u9xMA'
      },
      twitter: {
        handle: '@recapvid',
        url: 'https://x.com/recapvid'
      },
      linkedin: {
        handle: '@recapvid',
        url: 'https://linkedin.com/company/recapvid'
      },
      reddit: {
        handle: '@RecapVid',
        url: 'https://www.reddit.com/user/RecapVid/'
      }
    }
  },

  // Product Information
  product: {
    currentSport: 'NFL',
    videoLength: '2 minutes',
    supportedPlatforms: ['Sleeper'],
    features: {
      weeklyRecaps: 'Weekly recap video',
      personalizedContent: 'Personalized for your league',
      entertainment: 'Fun and engaging content',
      sharing: 'Easy to share with your league'
    }
  },

  // Sample Video Configuration
  sampleVideo: {
    url: 'https://www.youtube.com/watch?v=YdAbXsYzYWA',
    title: 'See it in action',
    description: 'Watch our AI-generated recap to see what your league could look like'
  },

  // Content for FAQ and other static content
  content: {
    faq: [
      {
        question: "How does the weekly recap work?",
        answer: "Every week, our AI analyzes your fantasy football league's performance and automatically creates a personalized recap video around 2-3 minutes. We roast everyone equally (keeping it clean and fun) and highlight the most exciting moments from your league."
      },
      {
        question: "How long are the recap videos?",
        answer: "Our recaps are typically 2-3 minutes, but the exact length varies each week depending on the content. We keep it short and sweet because we know you're busy - perfect for watching during your morning coffee or lunch break!"
      },
      {
        question: "What fantasy platforms do you support?",
        answer: "We currently support Sleeper fantasy leagues. We plan to support more platforms soon. Go to our Discord to tell us which platform you'd like us to add next!"
      },
      {
        question: "Can I share the recaps with my league?",
        answer: "Absolutely! Each recap is designed to be shared anywhere - upload to YouTube, post on social media, send to your group chat, or watch together during your next league meeting."
      },
      {
        question: "How much does it cost?",
        answer: "We offer flexible pricing plans starting at just $9.99/month per league. That's less than $1 per person in a 10-team league!"
      }
    ],
    cta: {
      hero: 'Get Started',
      features: 'Get Started'
    }
  }
};

export default sharedConfig;
